import { DottedBox, FoodsCheckbox } from "@foodpilot/foods";
import { Button, Stack, Typography, useTheme } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Property } from "src/api/sure-api/ssq/useGetOneSsqVersion";
import { usePropertyContext } from "../../context/usePropertyContext";
import AddIcon from "@mui/icons-material/Add";

type NoElementsForMultiProps = {
    property: Property;
    onAdd: () => void;
    onNotApplicable: (isNotApplicable: boolean) => void;
};
export const NoElementsForMulti = (props: NoElementsForMultiProps) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const { property, onAdd, onNotApplicable } = props;
    const { canEdit, getElement } = usePropertyContext();
    const element = getElement(property.id, 0);

    const isNotApplicableValue = !!element && element.value === "n/a";
    const [isNotApplicable, setNotApplicable] = useState<boolean>(isNotApplicableValue);

    return (
        <Stack direction="column" gap="16px">
            <DottedBox variant="themed">
                <Stack
                    alignItems={"start"}
                    gap={theme.spacing(1)}
                    padding={theme.spacing(2)}
                    sx={{ pointerEvents: isNotApplicable ? "none" : "all" }}
                >
                    <Typography variant="body-regular">
                        {t("questionnaire.add_first_multi.info", "Add a first element to answer this question")}
                    </Typography>
                    <Button
                        variant="text"
                        color="primary"
                        startIcon={<AddIcon />}
                        onClick={onAdd}
                        disabled={canEdit === false}
                        sx={{
                            height: "auto",
                            padding: 0,
                            opacity: isNotApplicable ? 0.36 : 1,
                        }}
                    >
                        <Typography variant="cta" color={theme.palette.primary[600]}>
                            {t("ajouter_un_element")}
                        </Typography>
                    </Button>
                </Stack>
            </DottedBox>
            <FoodsCheckbox
                values={["not_applicable"]}
                selectedItems={isNotApplicable === true ? ["not_applicable"] : []}
                onChange={(selectedValues: string[]) => {
                    const isNotApplicable = selectedValues.length > 0;

                    setNotApplicable(isNotApplicable);
                    onNotApplicable(isNotApplicable);
                }}
                getName={() => t("not_applicable")}
                FormControlLabelProps={{
                    sx: {
                        gap: "3px",
                        ".MuiTypography-root": {
                            ...theme.typography["body-regular"],
                        },
                    },
                }}
                CheckboxProps={{ disabled: !canEdit }}
            />
        </Stack>
    );
};
